module.exports = __webpack_public_path__ + "static/media/40x40-11.05db2fb4.png";